import loadable from '@loadable/component';

export const NewbuildingMapLoadable = loadable(() => import('./NewbuildingMapContainer'));
